import ZodConfig from 'constants/zodConfig'
import {z} from 'zod'

const name = {
    name: 'name',
    rules: {required: true},
    sm: 6,
    xs: 12,
}

const location = {
    name: 'location',
    rules: {required: true},
    sm: 6,
    xs: 12,
}

export const createStructuresField = {
    createStructure: {
        title: 'createStructure',
        items: {name, location},
    },
}

export const editStructuresField = {
    editStructure: {
        title: 'editStructure',
        items: {name, location},
    },
}

export const createStructuresFieldValidation = z.object({
    name: ZodConfig.string(),
    location: ZodConfig.string({min: 1}),
})
